import { useAuth } from "@/_core/hooks/useAuth";
import { useMemo, useCallback } from "react";

export function usePermissions() {
  const { user } = useAuth();

  const permissions = useMemo(
    () => new Set<string>((user as any)?.rolePermissions ?? []),
    [user],
  );

  const can = useCallback(
    (permission: string) => {
      if (!user) return false;
      if ((user as any).isSuperAdmin) return true;
      if ((user as any).tenantRole === "owner") return true;
      return permissions.has(permission);
    },
    [user, permissions],
  );

  const canAny = useCallback(
    (...perms: string[]) => perms.some((p) => can(p)),
    [can],
  );

  const canAll = useCallback(
    (...perms: string[]) => perms.every((p) => can(p)),
    [can],
  );

  return { can, canAny, canAll, permissions, roleName: (user as any)?.roleName ?? null };
}
